"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CCheckBox = _interopRequireDefault(require("01_core/components/materials/CCheckBox"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CSelect = _interopRequireDefault(require("01_core/components/materials/CSelect"));
var _CTextField = _interopRequireDefault(require("01_core/components/materials/CTextField"));
var _InputDateTime = _interopRequireDefault(require("01_core/components/select/InputDateTime"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringConsts = require("01_core/constants/stringConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _FormHelperText = _interopRequireDefault(require("@mui/material/FormHelperText"));
var _styles = require("@mui/material/styles");
var _Consts = require("../../common/consts/Consts");
var _ScenarioCheck = _interopRequireDefault(require("./ScenarioCheck"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const INDENT_PX = 12;
const SMALL_INDENT_PX = 6;
const OtherLabelTypography = (0, _styles.styled)(_Typography.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    marginTop: theme.spacing(1.2),
    marginRight: theme.spacing(1.2),
    display: 'inline-block',
    fontSize: theme.typography.body2.fontSize
  };
});
const IndentTypography = (0, _styles.styled)(_Typography.default)({
  marginLeft: "".concat(INDENT_PX, "px")
});
const PreLineIndentTypography = (0, _styles.styled)(_Typography.default)({
  whiteSpace: 'pre-line',
  marginLeft: "".concat(INDENT_PX, "px")
});
const KunrenNoneTypography = (0, _styles.styled)(_Typography.default)({
  marginLeft: "".concat(INDENT_PX, "px")
});
const TargetRiskCheckBox = (0, _styles.styled)(_CCheckBox.default)({
  marginLeft: "".concat(SMALL_INDENT_PX, "px")
});
const KunrenPeriodCheckBox = (0, _styles.styled)(_CCheckBox.default)({
  marginLeft: "".concat(SMALL_INDENT_PX, "px")
});
const StyledHelperText = (0, _styles.styled)(_FormHelperText.default)(() => ({
  marginRight: -300,
  width: 'calc(100%)'
}));

/**
 * 実施要領
 */
class ScenarioGuidanceField extends _react.default.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "changeGroupFlg", item => {
      let tgtRiskFlg = true;
      let kunrenPeriodFlg = true;
      this.props.guidanceEntry.checkStatusList.forEach(data => {
        if (data.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_01 && data.groupId === _CodeConsts.CODE.BCM_KR_GROUP.CODE_1) {
          if (data.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1) {
            tgtRiskFlg = false;
          }
        }
        if (data.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_01 && data.groupId === _CodeConsts.CODE.BCM_KR_GROUP.CODE_2) {
          if (data.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1) {
            kunrenPeriodFlg = false;
          }
        }
      });
      if (item.groupId === _CodeConsts.CODE.BCM_KR_GROUP.CODE_1) {
        return tgtRiskFlg;
      } else {
        return kunrenPeriodFlg;
      }
    });
    _defineProperty(this, "textCheck", () => {
      const text = this.props.guidanceEntry.checkStatusList.filter(item => {
        if (item.guidelineCd === _Consts.CONSTS.GUIDELINE_OTHER) {
          return true;
        }
        return false;
      });
      return text[0] && text[0].notes ? true : false;
    });
    // チェックボックス変更時
    _defineProperty(this, "changeCheckBox", (data, key) => value => {
      const list = this.props.guidanceEntry.checkStatusList.slice();
      const idx = list.indexOf(data);
      if (idx >= 0) {
        list[idx] = _objectSpread(_objectSpread({}, data), {}, {
          [key]: value ? _CodeConsts.CODE.FLG_VALUE.CODE_1 : _CodeConsts.CODE.FLG_VALUE.CODE_0
        });
        this.props.setEntry('checkStatusList')(list);
        this.props.setCheckStatusList && this.props.setCheckStatusList(list);
      }
    });
    // 備考テキスト変更時
    _defineProperty(this, "changeNote", data => value => {
      const list = this.props.guidanceEntry.checkStatusList.slice();
      const idx = list.indexOf(data);
      if (idx >= 0) {
        list[idx] = _objectSpread(_objectSpread({}, data), {}, {
          activityFlg: value === '' ? _CodeConsts.CODE.FLG_VALUE.CODE_0 : _CodeConsts.CODE.FLG_VALUE.CODE_1,
          notes: value
        });
        this.props.setEntry('checkStatusList')(list);
        this.props.setCheckStatusList && this.props.setCheckStatusList(list);
      }
    });
    _defineProperty(this, "targetRiskList", () => {
      const {
        guidanceEntry
      } = this.props;
      let targetRiskList = [];
      if (guidanceEntry.scenarioPolicyCd === _CodeConsts.CODE.BCM_SCENARIO.CODE_03 || !guidanceEntry.scenarioPolicyCd) {
        guidanceEntry.checkStatusList.forEach((item, index) => {
          if (item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_01) {
            if (item.guidelineCd === _Consts.CONSTS.GUIDELINE_OTHER) {
              targetRiskList.push(/*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
                key: index
              }, /*#__PURE__*/_react.default.createElement(OtherLabelTypography, {
                component: "span"
              }, item.contents), /*#__PURE__*/_react.default.createElement(_CTextField.default, {
                value: item.notes,
                onChange: this.changeNote(item),
                maxLength: 10,
                fullWidth: false
              })));
            } else {
              targetRiskList.push(/*#__PURE__*/_react.default.createElement(TargetRiskCheckBox, {
                key: index,
                label: item.contents,
                checked: item.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1,
                onChange: this.changeCheckBox(item, 'activityFlg'),
                color: "secondary",
                labelVariant: "body2"
              }));
            }
          }
        });
      } else {
        guidanceEntry.checkStatusList.forEach((item, index) => {
          if (item.guidelineCd === _Consts.CONSTS.GUIDELINE_OTHER) {
            if (item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_01 && item.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1) {
              if (targetRiskList.length !== 0) {
                targetRiskList.push(_stringConsts.STRING_CONSTS.TOUTEN_ZENKAKU);
              }
              targetRiskList.push(item.notes);
            }
          } else {
            if (item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_01 && item.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1) {
              if (targetRiskList.length !== 0) {
                targetRiskList.push(_stringConsts.STRING_CONSTS.TOUTEN_ZENKAKU);
              }
              targetRiskList.push(item.contents);
            }
          }
        });
        if (targetRiskList.length !== 0) {
          targetRiskList = /*#__PURE__*/_react.default.createElement(_Typography.default, null, targetRiskList);
        }
      }
      if (targetRiskList.length === 0) {
        targetRiskList.push(/*#__PURE__*/_react.default.createElement(IndentTypography, {
          key: "empty"
        }, _stringConsts.STRING_CONSTS.HYPHEN_ZENKAKU));
      }
      return targetRiskList;
    });
    _defineProperty(this, "kunrenPeriodList", () => {
      const {
        guidanceEntry
      } = this.props;
      let kunrenPeriodList = [];
      if (guidanceEntry.scenarioPolicyCd === _CodeConsts.CODE.BCM_SCENARIO.CODE_03 || !guidanceEntry.scenarioPolicyCd) {
        guidanceEntry.checkStatusList.forEach((item, index) => {
          if (item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_02 && (!this.changeGroupFlg(item) || this.textCheck())) {
            kunrenPeriodList.push(/*#__PURE__*/_react.default.createElement(KunrenPeriodCheckBox, {
              key: index,
              label: item.contents,
              checked: item.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1,
              onChange: this.changeCheckBox(item, 'activityFlg'),
              color: "secondary",
              labelVariant: "body2"
            }));
          }
        });
      } else {
        guidanceEntry.checkStatusList.forEach((item, index) => {
          if (item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_02 && item.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1) {
            if (kunrenPeriodList.length !== 0) {
              kunrenPeriodList.push(_stringConsts.STRING_CONSTS.TOUTEN_ZENKAKU);
            }
            kunrenPeriodList.push(item.contents);
          }
        });
        if (kunrenPeriodList.length !== 0) {
          kunrenPeriodList = /*#__PURE__*/_react.default.createElement(IndentTypography, null, kunrenPeriodList);
        }
      }
      if (kunrenPeriodList.length === 0) {
        kunrenPeriodList.push(/*#__PURE__*/_react.default.createElement(KunrenNoneTypography, {
          key: "empty"
        }, _stringConsts.STRING_CONSTS.HYPHEN_ZENKAKU));
      }
      return kunrenPeriodList;
    });
  }
  render() {
    var _errors$scenarioPolic, _errors$exercisesDt, _errors$riskDetailNot, _errors$kunrenPurpose, _errors$kunrenContent, _errors$supplement;
    const {
      intl,
      guidanceEntry,
      setEntry,
      kunrenInfo,
      getCodeItems,
      changeScenarioPolicy,
      errors,
      setFormValue
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        lg: 6,
        xs: 6
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_BCP_JISSHI_POLICY
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      required: true,
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_BCP_SCENARIO_POLICY
      }),
      hint: _labelConsts.LABEL.BCM_KUNREN_SCENARIO_POLICY_HELP
    }, /*#__PURE__*/_react.default.createElement(_CSelect.default, {
      value: guidanceEntry.scenarioPolicyCd,
      onChange: v => {
        changeScenarioPolicy(v);
      },
      items: getCodeItems(_CodeConsts.CODE.BCM_SCENARIO.KBN),
      setNone: false,
      error: !!(errors !== null && errors !== void 0 && errors.scenarioPolicyCd),
      helperText: errors === null || errors === void 0 || (_errors$scenarioPolic = errors.scenarioPolicyCd) === null || _errors$scenarioPolic === void 0 ? void 0 : _errors$scenarioPolic.message
    })))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        lg: 12,
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_REPORT_JISSHI_DETAIL
      }),
      hint: _labelConsts.LABEL.BCM_KUNREN_REPORT_JISSHI_DETAIL_HELP,
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_BCP_IMPLEMENTATION_YOTEI_ATE
      })
    }, /*#__PURE__*/_react.default.createElement(_InputDateTime.default, {
      value: guidanceEntry.exercisesDt,
      onChange: v => {
        setEntry('exercisesDt')(v);
        setFormValue && setFormValue('exercisesDt', v, {
          shouldValidate: false,
          shouldDirty: false
        });
      },
      name: 'exercisesDt',
      error: !!(errors !== null && errors !== void 0 && errors.exercisesDt),
      helperText: errors === null || errors === void 0 || (_errors$exercisesDt = errors.exercisesDt) === null || _errors$exercisesDt === void 0 ? void 0 : _errors$exercisesDt.message
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        lg: 12,
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_TGT_RISK
      }),
      hint: _labelConsts.LABEL.BCM_KUNREN_REPORT_TGT_RISK_HINT
    }, this.targetRiskList(), !!(errors !== null && errors !== void 0 && errors.checkStatusList) && /*#__PURE__*/_react.default.createElement(StyledHelperText, {
      error: true
    }, errors.checkStatusList.message))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        lg: 6,
        xs: 6
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_TGT_RISK_DETAIL
      }),
      hint: _labelConsts.LABEL.BCM_KUNREN_REPORT_TGT_RISK_DETAIL_HINT
    }, guidanceEntry.scenarioPolicyCd === _CodeConsts.CODE.BCM_SCENARIO.CODE_03 || !guidanceEntry.scenarioPolicyCd ? /*#__PURE__*/_react.default.createElement(_CTextField.default, {
      value: guidanceEntry.riskDetailNotes,
      onChange: v => {
        setEntry('riskDetailNotes')(v);
        setFormValue && setFormValue('riskDetailNotes', v, {
          shouldValidate: false,
          shouldDirty: false
        });
      },
      maxLength: 1000,
      multiline: true,
      rows: 3,
      error: !!(errors !== null && errors !== void 0 && errors.riskDetailNotes),
      helperText: errors === null || errors === void 0 || (_errors$riskDetailNot = errors.riskDetailNotes) === null || _errors$riskDetailNot === void 0 ? void 0 : _errors$riskDetailNot.message
    }) : /*#__PURE__*/_react.default.createElement(PreLineIndentTypography, null, _stringUtil.default.emptyToHyphen(guidanceEntry.riskDetailNotes)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        lg: 12,
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_PERIOD
      }),
      hint: _labelConsts.LABEL.BCM_KUNREN_REPORT_PERIOD_HINT
    }, this.kunrenPeriodList())), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        lg: 6,
        xs: 6
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_PURPOSE
      })
    }, guidanceEntry.scenarioPolicyCd === _CodeConsts.CODE.BCM_SCENARIO.CODE_03 || !guidanceEntry.scenarioPolicyCd ? /*#__PURE__*/_react.default.createElement(_CTextField.default, {
      value: guidanceEntry.kunrenPurpose,
      onChange: v => {
        setEntry('kunrenPurpose')(v);
        setFormValue && setFormValue('kunrenPurpose', v, {
          shouldValidate: false,
          shouldDirty: false
        });
      },
      maxLength: 1000,
      multiline: true,
      rows: 3,
      error: !!(errors !== null && errors !== void 0 && errors.kunrenPurpose),
      helperText: errors === null || errors === void 0 || (_errors$kunrenPurpose = errors.kunrenPurpose) === null || _errors$kunrenPurpose === void 0 ? void 0 : _errors$kunrenPurpose.message
    }) : /*#__PURE__*/_react.default.createElement(PreLineIndentTypography, null, _stringUtil.default.emptyToHyphen(guidanceEntry.kunrenPurpose)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        lg: 6,
        xs: 6
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_CONTENT
      })
    }, guidanceEntry.scenarioPolicyCd === _CodeConsts.CODE.BCM_SCENARIO.CODE_03 || !guidanceEntry.scenarioPolicyCd ? /*#__PURE__*/_react.default.createElement(_CTextField.default, {
      value: guidanceEntry.kunrenContent,
      onChange: v => {
        setEntry('kunrenContent')(v);
        setFormValue && setFormValue('kunrenContent', v, {
          shouldValidate: false,
          shouldDirty: false
        });
      },
      maxLength: 1000,
      multiline: true,
      rows: 3,
      error: !!(errors !== null && errors !== void 0 && errors.kunrenContent),
      helperText: errors === null || errors === void 0 || (_errors$kunrenContent = errors.kunrenContent) === null || _errors$kunrenContent === void 0 ? void 0 : _errors$kunrenContent.message
    }) : /*#__PURE__*/_react.default.createElement(PreLineIndentTypography, null, _stringUtil.default.emptyToHyphen(guidanceEntry.kunrenContent)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        lg: 6,
        xs: 6
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_SUPPLEMENT
      })
    }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
      value: guidanceEntry.supplement,
      onChange: v => {
        setEntry('supplement')(v);
        setFormValue && setFormValue('supplement', v, {
          shouldValidate: false,
          shouldDirty: false
        });
      },
      maxLength: 1000,
      multiline: true,
      rows: 3,
      error: !!(errors !== null && errors !== void 0 && errors.supplement),
      helperText: errors === null || errors === void 0 || (_errors$supplement = errors.supplement) === null || _errors$supplement === void 0 ? void 0 : _errors$supplement.message
    }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        lg: 12,
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_ScenarioCheck.default, {
      setEntry: setEntry,
      kunrenInfo: kunrenInfo,
      guidanceEntry: guidanceEntry
    })))));
  }
}
const mapStateToProps = state => ({
  guidanceErrMsg: state.bcmKunren.guidanceErrMsg
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _CodeUtil.withCodeUtil)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(ScenarioGuidanceField))));